import { cn } from "@/lib/cn"
import { toneCss } from "../format"
import type { MetricGridBlock } from "../types"

// Big-number tile grid. The CSS column count progressively unlocks via
// container queries — `xs` 1 col, `sm` 2 cols, `md`+ up to the `columns`
// the partner declared.
export function MetricGridBlockView({ block }: { block: MetricGridBlock }) {
  const max = block.columns === 4 ? 4 : block.columns === 3 ? 3 : 2
  const metrics = Array.isArray(block.metrics) ? block.metrics : []
  return (
    <div
      className={cn(
        "grid gap-3 valet-uidoc-metricgrid",
        max === 4 && "valet-uidoc-metricgrid-max4",
        max === 3 && "valet-uidoc-metricgrid-max3",
        max === 2 && "valet-uidoc-metricgrid-max2",
      )}
    >
      {metrics.map((m, idx) => {
        const css = toneCss(m.tone)
        return (
          <div
            key={`${m.label}-${idx}`}
            className={cn(
              "min-w-0 rounded-card border p-3",
              css.border,
              css.bg,
            )}
          >
            <div className="text-[11px] uppercase tracking-wide text-app-subtle">{m.label}</div>
            <div className={cn("mt-1 truncate text-2xl font-semibold", css.text)}>
              {m.value === null || m.value === undefined || m.value === ""
                ? "—"
                : String(m.value)}
            </div>
            {m.sub && <div className="mt-0.5 truncate text-[11px] text-app-muted">{m.sub}</div>}
          </div>
        )
      })}
    </div>
  )
}
